function mountBingResponse(res) {
  const bingAds = res?.results?.value || [];
  this.adContext.advertisers = bingAds.map((ad) => encodeURIComponent(ad?.displayUrl));
  const { dabuPlacementId } = this.dataset;
  const defaultConfig = { blocks: [{ placementId: dabuPlacementId }] };
  const bingOptions = this.win.amgAds.bingOptions || defaultConfig;
  bingOptions.blocks.forEach(({ placementId }, i) => {
    this.mountDabuResponse({ ...res, content: res.adContent[i] }, placementId);
    this.adPlacements[placementId].setMountedFlag();
  });
}

async function getBingAds() {
  // we only use one placement for bing ads
  // so we can destructure the first item in the array here.
  try {
    const {
      o, rtb, q, maxSKSResults,
    } = this.pageParams;

    const { bingOptions = { slug: '' } } = this.win.amgAds || {};

    const query = q || this.doc.title || bingOptions.slug;
    const dabuUrl = new URL(`${this.dabuUrl}/api/v2/ta/bing`);
    dabuUrl.searchParams.set('o', o);
    dabuUrl.searchParams.set('rtb', rtb);
    dabuUrl.searchParams.set('q', query);
    dabuUrl.searchParams.set('page', this.win.encodeURIComponent(this.win.location));
    dabuUrl.searchParams.set('pvid', this.pvId);

    if (maxSKSResults) {
      dabuUrl.searchParams.set('maxSKSResults', maxSKSResults);
    }

    // new features
    // url param bt overrides page-level config
    const template = this.pageParams.bt || bingOptions.template;
    if (bingOptions.template) dabuUrl.searchParams.set('template', template);
    if (Object.prototype.hasOwnProperty.call(bingOptions, 'repeatAds')) {
      if (bingOptions.repeatAds) dabuUrl.searchParams.set('repeatAds', 1);
    }
    if (bingOptions.blocks && Array.isArray(bingOptions.blocks)) {
      const c = bingOptions.blocks.map((b) => b.count).join(',');
      const ctaPosition = bingOptions.blocks.map((b) => b.ctaPosition).join(',');

      dabuUrl.searchParams.set('count', c);
      dabuUrl.searchParams.set('ctaPosition', ctaPosition);
    }
    const dabuRes = await this.callDabu(dabuUrl.toString());
    this.adContext.abTestBingTypeTag = dabuRes.bingTypeTag;
    this.adContext.bingAdUnitId = dabuRes.adUnitId;
    this.adContext.bingPropertyId = dabuRes.propertyId;
    this.mountBingResponse(dabuRes);
    this.firePageViewPixel();
  } catch (err) {
    // do nothing for bing search ads
    this.logger.error('error calling dabu', err);
  }
}

export { getBingAds, mountBingResponse };
